<template>
	<aside class="detail">
		<div class="detail-head">
			<div class="d-id"><span v-if="avatar" class="avatar lg" :class="brandClass">{{ avatar }}</span><div><div class="d-name">{{ title }}</div><div v-if="sub" class="d-sub">{{ sub }}</div></div></div>
			<div class="d-nav"><button class="navbtn" :disabled="!hasPrev" title="Previous" @click="$emit('prev')"><i class="fa-solid fa-chevron-up"></i></button><button class="navbtn" :disabled="!hasNext" title="Next" @click="$emit('next')"><i class="fa-solid fa-chevron-down"></i></button><button class="navbtn close" title="Close" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></button></div>
		</div>
		<div class="detail-body">
			<div v-if="$scopedSlots.actions" class="d-actions"><slot name="actions"></slot></div>
			<slot></slot>
			<slot name="footer"></slot>
		</div>
	</aside>
</template>

<script>
import { brandKey } from './PeBrandChip.vue'

export default {
	name: 'PeDetailRail',
	props: {
		title: { type: String, default: '' },
		sub: { type: String, default: '' },
		avatar: { type: String, default: '' },
		brand: { type: String, default: '' }, // TW, HG, CM, VT, TWK (or the Accounts2 keys) tints the avatar
		hasPrev: { type: Boolean, default: false },
		hasNext: { type: Boolean, default: false },
	},
	computed: {
		brandClass() { return brandKey(this.brand).toLowerCase() },
	},
	mounted() { window.addEventListener('keydown', this.onKey) },
	beforeDestroy() { window.removeEventListener('keydown', this.onKey) },
	methods: {
		onKey(e) {
			if (e.key === 'Escape') { this.$emit('close'); return }
			if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target && e.target.tagName)) return // arrows stay with the field being typed in
			if (e.key === 'ArrowDown' && this.hasNext) { e.preventDefault(); this.$emit('next') } else if (e.key === 'ArrowUp' && this.hasPrev) { e.preventDefault(); this.$emit('prev') }
		},
	},
}
</script>
